import { render, staticRenderFns } from "./socialBind.vue?vue&type=template&id=cc0787c0&scoped=true&"
import script from "./socialBind.vue?vue&type=script&lang=js&"
export * from "./socialBind.vue?vue&type=script&lang=js&"
import style0 from "./socialBind.vue?vue&type=style&index=0&id=cc0787c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0787c0",
  null
  
)

export default component.exports